import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setDueDate } from 'bundles/apex/deals/show/store/planner_bulk_actions/actions';

import pluralize from 'pluralize';

import Button from 'shared/button';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import Modal from 'components/modal';
import { formatDate } from 'helpers/formatters/date_time_formats';
import { Alert } from 'react-bootstrap-5';

export function DateChangeModal({ dueDate, selection, show, setDueDate, onClose, onUpdate }) {
  const [errors, setErrors] = useState([]);
  const selectionCount = Object.keys(selection).length;

  const updateTasks = async () => {
    const message = 
      `${selectionCount} ${pluralize('task', selectionCount)} ${pluralize('have', selectionCount)}` +
      ` been moved to ${formatDate(dueDate.date)}.`;

    const response = await onUpdate({ deadline: { ...dueDate, static: true, relative_date_id: null } }, message);
    if (response.errors) {
      setErrors(response.errors);
    } else {
      onClose();
    }
  };

  const resetModal = () => {
    setErrors([]);
    setDueDate(null);
  };

  const alertTitle = `Could not change due date for ${pluralize('task', selectionCount)}`;
  
  return (
    <Modal
      show={show}
      onHide={onClose}
      onShow={resetModal}
    >
      <Modal.Header closeButton>Move Due Date</Modal.Header>

      <Modal.Body className="form-vertical-field-container">
        {errors.length > 0 &&
          <Alert className="mb-4" variant="warning">
            <h6><strong>Whoops -</strong> {alertTitle}</h6>
            <ul>
              {errors.map((error, i) => <li key={i}>{error}</li>)}
            </ul>
          </Alert>
        }
        <ManagedFormGroup
          label="New Due Date"
          name="date"
          type="date"
          value={dueDate?.date}
          onChange={setDueDate}
        />
        <p>
          Are you sure you want to move the due date
          for <strong>{selectionCount}</strong> {pluralize('task', selectionCount)}?
        </p>
        <p>This will remove any association with critical dates.</p>
      </Modal.Body>

      <Modal.Footer>
        <Button.Cancel onClick={onClose} />
        <Button.Primary disabled={!dueDate} label="Yes, Update" onClick={updateTasks}/>
      </Modal.Footer>
    </Modal>
  );
}

DateChangeModal.propTypes = {
  dueDate: PropTypes.shape({
    date: PropTypes.string.isRequired
  }),
  selection: PropTypes.object.isRequired,
  setDueDate: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  dueDate: state.plannerBulkActions.dueDate,
  selection: state.plannerBulkActions.selection,
});

const mapDispatchToProps = {
  setDueDate
};

export default connect(mapStateToProps, mapDispatchToProps)(DateChangeModal);
